import React from 'react'
import useNonprofitOrgTeam from 'Hooks/useNonprofitOrgTeam/useNonprofitOrgTeam'
import { User } from 'TypeDefs/Goal'
import { Avatar, Tooltip } from './TaskItem.styled'

type UserAvatarProps = {
  user: User | null
}

export const UserAvatarV2 = ({ user }: UserAvatarProps) => {
  const { teamMap = {} } = useNonprofitOrgTeam()

  const getAvatarInitials = (owner: User | null): string => {
    if (!owner) return ''

    const teamMember = owner.id ? teamMap[owner.id.toString()] : undefined

    if (teamMember) {
      if (teamMember.firstName && teamMember.lastName) {
        return `${teamMember.firstName[0]}${teamMember.lastName[0]}`.toUpperCase()
      }
      if (teamMember.firstName) {
        return `${teamMember.firstName[0]}${
          teamMember.firstName[1] || ''
        }`.toUpperCase()
      }
      if (teamMember.email) {
        return `${teamMember.email[0]}${
          teamMember.email[1] || ''
        }`.toUpperCase()
      }
    }
    if (owner.firstName && owner.lastName) {
      return `${owner.firstName[0]}${owner.lastName[0]}`.toUpperCase()
    }
    if (owner.firstName) {
      return `${owner.firstName[0]}${owner.firstName[1] || ''}`.toUpperCase()
    }

    return ''
  }

  const getTooltipText = (): string => {
    if (!user) return 'Unassigned'
    if (!teamMap) return 'Team information unavailable'
    const teamMember = user.id ? teamMap[user.id.toString()] : undefined

    if (teamMember && teamMember?.firstName.includes('@')) {
      return `Owned by ${teamMember?.email}`
    }

    if (teamMember) {
      return `Owned by ${teamMember.firstName} ${teamMember.lastName}`
    }

    if (user && user.firstName && user.lastName) {
      return `Owned by ${user.firstName} ${user.lastName}`
    }

    return 'Unassigned'
  }

  const initials = getAvatarInitials(user)

  return (
    <Tooltip title={getTooltipText()} placement='top' arrow>
      <Avatar>{initials}</Avatar>
    </Tooltip>
  )
}
